// CLI v0.8 — `cloudgrid env …` subcommand group. Spec v17 §13.8.

import { Command } from 'commander';
import { envListCommand } from './list.js';
import { envGetCommand } from './get.js';
import { envSetCommand } from './set.js';
import { envUnsetCommand } from './unset.js';

export const envCommand = new Command('env')
  .description('Manage runtime env vars (ConfigMap-backed; rolling restart on update)')
  .addCommand(envListCommand)
  .addCommand(envGetCommand)
  .addCommand(envSetCommand)
  .addCommand(envUnsetCommand);
